<template>
  <i class="el-icon-back back-arrow" :title="'返回'"></i>
</template>

<script>
export default {}
</script>

<style lang="scss">
$fontColor: #eee;
.back-arrow {
  position: absolute;
  left: 0vw;
  top: 1vh;
  font-size: 1.25vw;
  cursor: pointer;
  color: $fontColor;
  z-index: 9999;
}
</style>
